
import { Message } from '../enums/message';

export class ValidationResponse {

 get actionable() { return this.show && !this.disabled; }

 constructor( public show: boolean, public disabled: boolean, public msg: Message, public valid:Boolean = true) {}}

